// extracted by mini-css-extract-plugin
export default {"help-icon":"help-icon","helpIcon":"help-icon","tooltip":"tooltip"};